import Vue from 'vue'
import Router from 'vue-router'

import layout from '@/views/layout/layout'

import login from '@/views/login'
import register from '@/views/register'
import forgotPassword from '@/views/forgotPassword'

import user from '@/views/weeklyReport/user'
import statusListByMonth from '@/views/weeklyReport/statusListByMonth'
import weeklyReport from '@/views/weeklyReport/index'
import post from '@/views/weeklyReport/post'

import project from '@/views/project/project'
// import projectType from '@/views/project/projectType'
import projectDetail from '@/views/project/projectDetail'

import userSpentTime from '@/views/report/userSpentTime'
import taskSpentTime from '@/views/report/taskSpentTime'
import projectSpentTime from '@/views/report/projectSpentTime'
import userSpentTimeGroupByProject from '@/views/report/userSpentTimeGroupByProject'
import monthlySpentTimeGroupByProject from '@/views/report/monthlySpentTimeGroupByProject'
import monthlySpentTimeGroupByTask from '@/views/report/monthlySpentTimeGroupByTask'

import organization from '@/views/setting/organization'
import task from '@/views/setting/task'
import roleManage from '@/views/setting/role'
import roleDetail from '@/views/setting/roleDetail'
import password from '@/views/setting/password'
import settings from '@/views/setting/settings'
import dictionary from '@/views/setting/dictionary'
import dictionaryItem from '@/views/setting/dictionaryItem'

import help from '@/views/help/help'
import echartsTest from '@/views/help/echartsTest'


Vue.use(Router)

export const asyncRouterMap = [{
    path: '/login',
    component: login,
    hidden: true
  },
  {
    path: '/register',
    component: register,
    hidden: true
  },
  {
    path: '/forgotPassword',
    component: forgotPassword,
    hidden: true
  },
  {
    path: '/weeklyReport',
    component: layout,
    redirect: '/post',
    // icon: 'icon-gailan',
    name: '周 报',
    noDropdown: true,
    children: [
      { path: 'post', component: post, noDropdown: true,name: '填写',children:[]},
      { path: '/', name: '查询',component: weeklyReport, noDropdown: false,
      children:
      [
        { path: 'user', component: user, name: '按个人'},
        { path: 'statusListByMonth', component: statusListByMonth, name: '按组织机构',
            role:['WeeklyReport_Search_ByOrganization_Scoped','WeeklyReport_Search_ByOrganization_All']
        }
      ]}
      // { path: '', name: '统计',
      //     role:["WeeklyReport_SpentTimeReport_Scoped","WeeklyReport_SpentTimeReport_All"], 
      //     component: weeklyReport, noDropdown: false,
      // children:
      // [
      //   { path: 'userSpentTime', component: userSpentTime, name: '人员工时统计'},
      //   { path: 'projectSpentTime', component: projectSpentTime, name: '项目工时统计'},
      //   { path: 'taskSpentTime', component: taskSpentTime, name: '一般工时统计'},
      // ]}
      
    ]
  },
  {
    path: '/project',
    component: layout,
    redirect: '/project',
    // icon: 'icon-gailan',
    name: '项目管理',
    role:['Project','Project_Settings'],
    children: [
      { path: 'project', component: project,  noDropdown: true,name: '项目管理',children:[],role:['Project_Settings']},
      // { path: 'projectType', component: projectType,  noDropdown: true,name: '项目类型',children:[],role:['Project_Settings']},
      { path: 'projectDetail', component: projectDetail,  noDropdown: true,name: '任务类别',children:[],role:['Project_Settings'], hidden: true}
      
      // { path: '', name: '统计',
      // // role:["WeeklyReport_SpentTimeReport_Scoped","WeeklyReport_SpentTimeReport_All"], 
      // component: weeklyReport, noDropdown: false,
      // children:
      // [
      //   { path: 'userSpentTimeGroupByProject', component: userSpentTimeGroupByProject, name: '人员工时统计'},
      // ]}

    ]
  },
// {
//     path: '/report2',
//     component: layout,
//      redirect: '/userSpentTime',
//     // icon: 'icon-gailan',
//     name: '统计数据旧',
//     role:['Report_Scoped','Report_All'],
//     children: [
//       { path: '', name: '人员相关统计',
//       // role:["WeeklyReport_SpentTimeReport_Scoped","WeeklyReport_SpentTimeReport_All"], 
//       component: weeklyReport, noDropdown: false,
//       children:
//       [
//         { path: 'userSpentTime', component: userSpentTime, name: '人员工时统计'},
//         { path: 'taskSpentTime', component: taskSpentTime, name: '一般工时统计'}
//       ]},

//       { path: '', name: '项目相关统计',
//       // role:["WeeklyReport_SpentTimeReport_Scoped","WeeklyReport_SpentTimeReport_All"], 
//       component: weeklyReport, noDropdown: false,
//       children:
//       [
//         { path: 'projectSpentTime', component: projectSpentTime, name: '项目工时统计'},
//         { path: 'monthlySpentTimeGroupByProject', component: monthlySpentTimeGroupByProject, name: '月度工时统计'},
//         { path: 'userSpentTimeGroupByProject', component: userSpentTimeGroupByProject, name: '人员工时统计'}
//       ]},

//     ]
// },

{
  path: '/report',
  component: layout,
   redirect: '/userSpentTime',
  // icon: 'icon-gailan',
  name: '统计数据',
  role:['Report_Scoped','Report_All'],
  children: [
    { path: 'userSpentTime', component: userSpentTime, name: '人员工时统计', noDropdown: true,children:[]},

    { path: '', name: '日常工作工时统计',
      // role:["WeeklyReport_SpentTimeReport_Scoped","WeeklyReport_SpentTimeReport_All"], 
      component: weeklyReport, noDropdown: false,
      children:
      [
        { path: 'monthlySpentTimeGroupByTask', component: monthlySpentTimeGroupByTask, name: '按月度'},
        { path: 'taskSpentTime', component: taskSpentTime, name: '按人员'}
      ]
    },

    { path: '', name: '项目工时统计',
      // role:["WeeklyReport_SpentTimeReport_Scoped","WeeklyReport_SpentTimeReport_All"], 
      component: weeklyReport, noDropdown: false,
      children:
      [
        { path: 'monthlySpentTimeGroupByProject', component: monthlySpentTimeGroupByProject, name: '按月度'},
        { path: 'projectSpentTime', component: projectSpentTime, name: '按人员'}
      ]
    }
   
  ]
},

  {
    path: '/setting',
    component: layout,
    redirect: '/password',
    // icon: 'icon-gailan',
    name: '设 置',
    // role:['Settings','Settings_Organization','Settings_BaseData'],
    children: [
      { path: 'password', component: password, name: '密码', noDropdown: true,children:[]},
      { path: 'organization', component: organization, name: '组织与人员', noDropdown: true,children:[],  role:['Settings_Organization']},
      { path: 'role', component: roleManage, name: '角色权限',noDropdown: true,children:[], role:['Settings_Organization']},
      { path: 'task', component: task, name: '日常工作',noDropdown: true,children:[], role:['Settings_BaseData']},
      { path: 'roleDetail', component: roleDetail, noDropdown:false,children:[], hidden: true},
      { path: 'settings', component: settings, name: '系统设置', noDropdown: true,children:[],role:['Settings_BaseData']},
      { path: 'dictionary', component: dictionary, name: '字典', noDropdown: true,children:[],role:['Settings_BaseData']},
      { path: 'dictionaryItem', component: dictionaryItem, noDropdown:false,children:[], hidden: true},
    ]
  },

  {
    path:'/help',
    component: layout,
    redirect: '/help',
    name: '帮 助',
    children: [
      { path: 'help', component: help, name: '帮助', noDropdown: true,children:[]}
   //   { path: 'echartsTest', component: echartsTest, name: 'echartsTest', noDropdown: true,children:[]}
    ]
  }

  


]

export default new Router({
  // mode: 'history', //后端支持可开
  scrollBehavior: () => ({ y: 0 }),
  routes: asyncRouterMap
})



// WEBPACK FOOTER //
// ./src/router/index.js